import { successStyle } from './console-styles';

export const getPluginTimeoutMs = (): number => {
    const fromEnv = window.environments?.PLUGIN_TIMEOUT_MS
        ? parseInt(window.environments.PLUGIN_TIMEOUT_MS, 10)
        : 10000;
    return isNaN(fromEnv) ? 10000 : fromEnv;
};

export const listenerPromise = (event: string, message?: string, timeoutMs?: number) => {
    return new Promise<void>((resolve, reject) => {
        let timer: ReturnType<typeof setTimeout> | undefined;

        const listener = () => {
            if (timer) clearTimeout(timer);
            console.log(`%c✔️${message}`, successStyle);
            window.removeEventListener(event, listener);
            resolve();
        };
        window.addEventListener(event, listener);

        if (timeoutMs) {
            timer = setTimeout(() => {
                window.removeEventListener(event, listener);
                reject(new Error(`Timed out waiting for '${event}' after ${timeoutMs}ms`));
            }, timeoutMs);
        }
    });
};
